import SueldosAPI from '@/api/sueldos/sueldos';

export default {
  // Condiciones Laborales
  async fetchCondiciones({ commit }, params) {
    const { data } = await SueldosAPI.condiciones.index(params);
    commit('setCondiciones', data);
    return data;
  },

  fetchCondicion(_, id) {
    return SueldosAPI.condiciones.show(id);
  },

  crearCondicion(_, data) {
    return SueldosAPI.condiciones.create(data);
  },

  actualizarCondicion(_, { id, data }) {
    return SueldosAPI.condiciones.update(id, data);
  },

  eliminarCondicion(_, id) {
    return SueldosAPI.condiciones.destroy(id);
  },

  // Registro de Horas
  async fetchHoras({ commit }, params) {
    const { data } = await SueldosAPI.horas.index(params);
    commit('setHoras', data);
    return data;
  },

  fetchHora(_, id) {
    return SueldosAPI.horas.show(id);
  },

  crearHora(_, data) {
    return SueldosAPI.horas.create(data);
  },

  actualizarHora(_, { id, data }) {
    return SueldosAPI.horas.update(id, data);
  },

  eliminarHora(_, id) {
    return SueldosAPI.horas.destroy(id);
  },

  // Liquidaciones
  async fetchLiquidaciones({ commit }, params) {
    const { data } = await SueldosAPI.liquidaciones.index(params);
    commit('setLiquidaciones', data);
    return data;
  },

  fetchLiquidacion(_, id) {
    return SueldosAPI.liquidaciones.show(id);
  },

  crearLiquidacion(_, data) {
    return SueldosAPI.liquidaciones.create(data);
  },

  actualizarLiquidacion(_, { id, data }) {
    return SueldosAPI.liquidaciones.update(id, data);
  },

  prepararLiquidacion(_, params) {
    return SueldosAPI.liquidaciones.preparar(params);
  },

  recalcularLiquidacion(_, id) {
    return SueldosAPI.liquidaciones.recalcular(id);
  },

  agregarConceptoLiquidacion(_, { id, data }) {
    return SueldosAPI.liquidaciones.agregarConcepto(id, data);
  },

  eliminarConceptoLiquidacion(_, { id, conceptoId }) {
    return SueldosAPI.liquidaciones.eliminarConcepto(id, conceptoId);
  },

  confirmarLiquidacion(_, { id, data }) {
    return SueldosAPI.liquidaciones.confirmar(id, data);
  },

  anularLiquidacion(_, id) {
    return SueldosAPI.liquidaciones.anular(id);
  },

  descargarPdfLiquidacion(_, id) {
    return SueldosAPI.liquidaciones.pdf(id);
  },
};
